import { NgModule } from '@angular/core';

import { FormControlTouchStatusPatchDirective } from './form-control-touch-status-patch.directive';

@NgModule({
  declarations: [FormControlTouchStatusPatchDirective],
  exports: [FormControlTouchStatusPatchDirective],
})
export class FormControlTouchStatusPatchModule {}

export { FormControlTouchStatusPatchDirective };
